
export const customStyles = {
    row: {
        style: {
            padding: '16px'

        }
    },
    headCells: {
        style: {
            fontSize: '10px'
        }
    },
    headRow: {
        style: {
            minWidth: 'fit-content',
            minHeight: '40px',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid'
        },
        denseStyle: {
            minHeight: '32px'
        }
    },
    rows: {
        style: {
            placeItems: 'center',
            height: '4.5rem !important',
            minHeight: '1rem',
            fontSize: '12px',
            paddin: '7px',
            fontFamily: 'sans-serif'
        }
    },
    cells: {
        style: {
            height: '2rem !important'
        }
    },
    header: {
        style: {
            height: '20px !important'
        }
    }
}